const HELPERS = {
  priceWithThousands(price) {
    return price.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.');
  }
}

export { HELPERS };
